/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { ApiWorkflowSettingUpsertRequest, SettingResponse, SettingsResponse } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiWorkflowSettingController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-workflow-setting-controller
   * @name GetAllByOrg
   * @request GET:/api/v1/workflow/settings
   */
  getAllByOrg = (params: RequestParams = {}) =>
    this.http.request<SettingsResponse, any>({
      path: `/v1/workflow/settings`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAllByOrgPath = '/v1/workflow/settings'
  static getAllByOrgMethod = 'GET'
  /**
   * No description
   *
   * @tags api-workflow-setting-controller
   * @name Upsert
   * @request PUT:/api/v1/workflow/settings
   */
  upsert = (data: ApiWorkflowSettingUpsertRequest, params: RequestParams = {}) =>
    this.http.request<SettingResponse, any>({
      path: `/v1/workflow/settings`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static upsertPath = '/v1/workflow/settings'
  static upsertMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-workflow-setting-controller
   * @name GetByCodeAndOrg
   * @request GET:/api/v1/workflow/settings/code/{settingCode}
   */
  getByCodeAndOrg = (settingCode: string, params: RequestParams = {}) =>
    this.http.request<SettingResponse, any>({
      path: `/v1/workflow/settings/code/${settingCode}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByCodeAndOrgPath = '/v1/workflow/settings/code/${settingCode}'
  static getByCodeAndOrgMethod = 'GET'
}
